import { handleSitecoreChrome } from './rendering'

export const ExtendSitecore = (Vue, VueRoot) => {
  if (typeof Sitecore !== typeof undefined && Sitecore.PageModes) {
    /**
     * Extend the Sitecore chrome reload function
     */
    if (Sitecore.PageModes.Chrome) {
      Sitecore.PageModes.Chrome = Sitecore.PageModes.Chrome.extend({
        reload() {
          this.base()
          handleSitecoreChrome(this, VueRoot, Vue)
        }
      }, Sitecore.PageModes.Chrome.prototype)
    }

    /**
     * Extend the Sitecore placeholder chrome type
     */
    if (Sitecore.PageModes.ChromeTypes) {
      Sitecore.PageModes.ChromeTypes.Placeholder = Sitecore.PageModes.ChromeTypes.Placeholder.extend({
        insertRendering(data, openProperties) {
          this.base(data, openProperties)
          /**
           * The setTimeout() is a bit ugly but is necessary
           * to prevent an async race condition with a jQuery animation
           */
          setTimeout(() => {
            handleSitecoreChrome(this.chrome, VueRoot, Vue, true)
          }, 500)
        }
      }, Sitecore.PageModes.ChromeTypes.Placeholder)
    }
  }
}
